import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { isSubdomain } from 'utils/domain';
import { useAppSelector } from './redux';
import { useDispatch } from 'react-redux';
import { getPortalCustomization, setCustomization } from 'redux/customizations/slice';
import { ICourse } from '../interface/course';

export const useCustomization = () => {
  const { portal, ...customizations } = useAppSelector((store) => store.customizations);
  const dispatch = useDispatch();
  const course = useAppSelector<ICourse>((store) => store?.course);
  const { courseHash } = useParams<{ courseHash: string }>();

  useEffect(() => {
    if (!isSubdomain() || courseHash) return;
    if (portal) {
      dispatch(setCustomization(portal));
    } else {
      dispatch(getPortalCustomization());
    }
  }, [dispatch, courseHash, portal]);

  useEffect(() => {
    if (courseHash) {
      dispatch(
        setCustomization({
          ...course.customizations,
          support_external_url: course?.support_external_url,
          header_logo: course?.logo,
        })
      );
    }
  }, [dispatch, courseHash, course]);

  useEffect(() => {
    const isSubdomainOrCourse = isSubdomain() || courseHash;
    if (!isSubdomainOrCourse) {
      dispatch(
        setCustomization({
          header_background_color: null,
          header_link_color: null,
          header_logo: null,
          support_external_url: null,
        })
      );
    }
  }, [courseHash, dispatch]);

  return customizations;
};
